import { useRef, useState, useEffect } from "react";

/**
 * Cinematic muted-autoplay preview media used in room cards.
 * Renders a hero image immediately and lazy-mounts a short looping video
 * on top once it enters the viewport.
 */
export default function RoomPreviewMedia({ image, video, alt, className = "" }) {
    const wrapRef = useRef(null);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        if (mounted || !wrapRef.current) return;
        const io = new IntersectionObserver(
            (entries) => entries.forEach((e) => e.isIntersecting && setMounted(true)),
            { rootMargin: "300px" }
        );
        io.observe(wrapRef.current);
        return () => io.disconnect();
    }, [mounted]);

    return (
        <div ref={wrapRef} className={`relative overflow-hidden ${className}`}>
            <img
                src={image}
                alt={alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover"
            />
            {video && mounted && (
                <video
                    key={video}
                    className="absolute inset-0 w-full h-full object-cover transition-opacity duration-700"
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="metadata"
                    poster={image}
                    aria-hidden="true"
                >
                    <source src={video} type="video/mp4" />
                </video>
            )}
        </div>
    );
}
